const ServicesSection = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/5519981868997', '_blank');
  };

  const services = [
    {
      title: 'Desentupimento de Pias',
      description:
        'Desentupimento de pia de cozinha e banheiro em Campinas e Região com equipamentos profissionais. Resolvemos entupimentos causados por resíduos de alimentos, gordura e sabão. Atendimento 24 horas com garantia total do serviço.',
      image: 'https://public.readdy.ai/ai/img_res/4240cebc904fb4ac37f702cf24266a1a.jpg',
      alt: 'Desentupimento de Pias Campinas e Região',
    },
    {
      title: 'Desentupimento de Vasos Sanitários',
      description:
        'Desentupimento de vaso sanitário urgente em Campinas e Região. Técnicos especializados com equipamentos modernos para desobstruir vasos entupidos por papel higiênico, objetos ou problemas na tubulação. Chegamos em 30 minutos!',
      image: 'https://readdy.ai/api/search-image?query=professional%20technician%20repairing%20white%20toilet%20bowl%20with%20modern%20plumbing%20equipment%20in%20clean%20bathroom%2C%20professional%20service%20work%2C%20simple%20bright%20background%2C%20realistic%20photography%20style%2C%20high%20quality%20detailed%20photo&width=800&height=600&seq=service-toilet-02&orientation=landscape',
      alt: 'Desentupimento de Vasos Sanitários 24h',
    },
    {
      title: 'Desentupimento de Ralos',
      description:
        'Desentupimento de ralo de banheiro, cozinha e área externa em Campinas e Região. Atendimento 24 horas todos os dias, inclusive finais de semana e feriados. Eliminamos entupimentos por cabelos, resíduos e sujeira acumulada.',
      image: 'https://readdy.ai/api/search-image?query=professional%20worker%20cleaning%20bathroom%20floor%20drain%20with%20professional%20equipment%2C%20close-up%20view%20of%20drain%20grate%20and%20cleaning%20tools%2C%20modern%20tile%20floor%2C%20simple%20clean%20background%2C%20realistic%20service%20photo%2C%20high%20quality%20image&width=800&height=600&seq=service-drain-03&orientation=landscape',
      alt: 'Desentupimento de Ralos 24 Horas',
    },
    {
      title: 'Desentupimento de Canos e Tubulações',
      description:
        'Desentupimento de canos residenciais e comerciais em Campinas e Região com hidrojateamento profissional. Limpeza completa de tubulações entupidas por gordura, raízes ou incrustações. Serviço limpo sem quebrar pisos ou paredes.',
      image: 'https://readdy.ai/api/search-image?query=professional%20plumber%20inspecting%20exposed%20water%20pipes%20and%20plumbing%20system%20with%20inspection%20camera%2C%20modern%20diagnostic%20equipment%2C%20technical%20service%20work%2C%20clean%20simple%20background%2C%20realistic%20industrial%20photography%2C%20high%20quality%20detailed%20photo&width=800&height=600&seq=service-pipes-04&orientation=landscape',
      alt: 'Desentupimento de Canos Profissional',
    },
    {
      title: 'Desentupimento de Caixa de Gordura',
      description:
        'Desentupimento de caixa de gordura residencial e comercial em Campinas e Região. Serviço especializado para restaurantes, padarias e residências. Evite refluxo de esgoto e mau cheiro com manutenção preventiva profissional.',
      image: 'https://readdy.ai/api/search-image?query=professional%20worker%20cleaning%20outdoor%20grease%20trap%20with%20specialized%20vacuum%20equipment%2C%20commercial%20maintenance%20service%2C%20outdoor%20setting%20with%20professional%20tools%2C%20simple%20background%2C%20realistic%20industrial%20photography%2C%20high%20quality%20photo&width=800&height=600&seq=service-grease-05&orientation=landscape',
      alt: 'Desentupimento de Caixa de Gordura',
    },
    {
      title: 'Limpeza de Caixa de Gordura',
      description:
        'Limpeza de caixa de gordura preventiva em Campinas e Região. Manutenção periódica evita entupimentos graves e multas sanitárias. Serviço rápido com descarte ecológico conforme normas ambientais. Orçamento sem compromisso!',
      image: 'https://readdy.ai/api/search-image?query=professional%20maintenance%20team%20performing%20preventive%20grease%20trap%20cleaning%20with%20eco-friendly%20equipment%2C%20outdoor%20maintenance%20work%20with%20safety%20gear%2C%20clean%20simple%20background%2C%20professional%20service%20photography%2C%20natural%20daylight%2C%20high%20quality%20realistic%20photo&width=800&height=600&seq=service-grease-clean-06&orientation=landscape',
      alt: 'Limpeza de Caixa de Gordura Preventiva',
    },
    {
      title: 'Desentupimento de Esgoto',
      description:
        'Desentupimento de rede de esgoto em Campinas e Região com vídeo-inspeção e hidrojateamento de alta pressão. Identificamos e resolvemos obstruções em redes coletoras, ramais e caixas de inspeção. Técnicos certificados e equipamentos de última geração.',
      image: 'https://readdy.ai/api/search-image?query=professional%20sewer%20technician%20using%20video%20inspection%20camera%20equipment%20in%20underground%20sewer%20system%2C%20modern%20diagnostic%20technology%20with%20monitor%20screen%2C%20technical%20service%20work%2C%20simple%20background%2C%20realistic%20industrial%20photography%2C%20high%20quality%20detailed%20photo&width=800&height=600&seq=service-sewer-07&orientation=landscape',
      alt: 'Desentupimento de Esgoto Profissional',
    },
    {
      title: 'Limpeza de Fossa Séptica',
      description:
        'Limpeza de fossa séptica e sumidouro em Campinas e Região com caminhão limpa-fossa. Esgotamento completo, higienização e manutenção preventiva. Evite transbordamentos e contaminação do solo. Atendimento emergencial 24 horas!',
      image: 'https://readdy.ai/api/search-image?query=professional%20septic%20tank%20cleaning%20service%20with%20specialized%20vacuum%20truck%2C%20large%20industrial%20truck%20with%20hoses%20and%20equipment%2C%20outdoor%20service%20work%2C%20simple%20clean%20background%2C%20realistic%20commercial%20photography%2C%20high%20quality%20photo&width=800&height=600&seq=service-septic-08&orientation=landscape',
      alt: 'Limpeza de Fossa Séptica 24h',
    },
    {
      title: 'Hidrojateamento Profissional',
      description:
        'Hidrojateamento de alta pressão em Campinas e Região para limpeza profunda de tubulações. Remove gordura, incrustações e raízes sem danificar os canos. Tecnologia de ponta para desentupimento definitivo com garantia de 6 meses.',
      image: 'https://readdy.ai/api/search-image?query=professional%20high-pressure%20water%20jetting%20machine%20cleaning%20pipes%2C%20powerful%20industrial%20hydro%20jetting%20equipment%20with%20water%20spray%2C%20modern%20technology%20system%2C%20simple%20clean%20background%2C%20realistic%20industrial%20photography%2C%20high%20quality%20detailed%20photo&width=800&height=600&seq=service-hydro-09&orientation=landscape',
      alt: 'Hidrojateamento de Alta Pressão',
    },
  ];

  return (
    <section id="servicos" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
            Serviços de Desentupimento em Campinas e Região
          </h2>
          <p className="text-xl text-gray-600 mb-6">
            Soluções completas em desentupimento 24 horas com equipamentos profissionais e garantia
            total
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-green-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow transform hover:scale-105 duration-300 flex flex-col"
            >
              <div className="relative">
                <img
                  alt={service.alt}
                  title={service.alt}
                  className="w-full h-48 object-cover object-top"
                  src={service.image}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              </div>
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  <strong>{service.title}</strong>
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4 flex-grow">{service.description}</p>
                <button
                  onClick={handleWhatsApp}
                  className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-lg font-medium transition-colors flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer w-full"
                >
                  <i className="ri-whatsapp-line"></i>
                  <span>Orçamento Grátis</span>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center bg-gradient-to-r from-blue-600 to-green-600 rounded-2xl p-12 text-white">
          <h3 className="text-3xl font-bold mb-4">🚨 Emergência de Desentupimento em Campinas e Região?</h3>
          <p className="text-xl mb-6 max-w-3xl mx-auto">
            <strong>Atendimento 24 horas</strong> para desentupimento urgente! Equipe especializada
            chega em até 30 minutos na sua região com equipamentos profissionais. Orçamento gratuito
            pelo WhatsApp agora!
          </p>
          <button
            onClick={handleWhatsApp}
            className="bg-white text-green-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 flex items-center justify-center space-x-2 mx-auto whitespace-nowrap cursor-pointer shadow-xl"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            <span>Chame pelo WhatsApp</span>
          </button>
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 max-w-5xl mx-auto leading-relaxed">
            <strong>Desentupidora da Cidade Nº1 Campinas e Região</strong> - Empresa especializada em{' '}
            <strong>desentupimento 24 horas</strong> atendendo residências, comércios e indústrias em
            toda região de Campinas e Região. Oferecemos serviços de
            <strong>
              {' '}
              desentupimento de pias, vasos sanitários, ralos, canos, caixas de gordura, esgotos e
              limpeza de fossas
            </strong>{' '}
            com
            <strong> hidrojateamento profissional</strong>. Técnicos certificados, equipamentos
            modernos e <strong>garantia de 3 meses</strong>. Atendimento emergencial com chegada em
            30 minutos. <strong>Orçamento gratuito</strong> e parcelamento em até 6x sem juros.
            Cobrimos qualquer orçamento da concorrência!
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;